export default "__VITE_ASSET__DRpw80Ur__"